import React from 'react'
import doctor from '../img/doctores.jpg'
import { NavLink } from 'react-router-dom'

const Header = () => {
    return (
        <>

            <div className='header'>

                <h2>Our Mission Our mission is to provide accessible, affordable, and high-quality healthcare, ensuring every patient receives the best possible treatment tailored to their unique needs.</h2>

                <h3>Dr. Minhaz Ahmad MD, DNB, PDCC, (HEPATOLOGY)</h3>
                <h3>Former Consultant</h3>

                <h4>Dr. Ram Manohar Lohia Institute of Medical Sciences <br />
                    Lucknow SGPGI MS  Lucknow <br />
                    AIIMS New Delhi <br />
                    JASLOK Hospital Mumbai</h4>

                <img src={doctor} />



                <div className='new-back'>

                    <div className='constone'>
                        <NavLink className='linked' to='/Contact'>
                            Book Appointment
                        </NavLink>
                    </div>

                    <div className='constone'>
                        <NavLink className='linked' to='/Contact'>
                            Home Care
                        </NavLink>
                    </div>

                    <div className='constone'>
                        <NavLink className='linked' to='/Contact'>
                            Get Health
                        </NavLink>
                    </div>

                    <div className='constone'>
                        <NavLink className='linked' to='/Contact'>
                            Health Checkup
                        </NavLink>
                    </div>


                </div>






            </div>


        </>
    )
}

export default Header
